const campaignSystemEvents = Object.freeze({
  EVENT_SESSION_START: 'session_start',
  EVENT_PREFERENCE_TRIGGER: 'preference_trigger'
})

const campaignSystemEventTitles = Object.freeze({
  preference_trigger: 'CampaignForm_Events_Event_Consent_Preference_Change',
  session_start: 'CampaignForm_Events_Event_Session_Start'
})

export { campaignSystemEvents, campaignSystemEventTitles }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/CampaignSystemEventEnum.js